<template>
    <div class="m-2">
        <div class="d-flex w-100 ps-3 pe-3" style="height: 80vh;">
            <div class="flex-grow-1 ms-3" ref="main_center_div">
              <div v-if="main_center_stream != null" class="d-flex justify-content-center">
                <video autoplay playsinline :srcObject="main_center_stream" :muted="true"
                :height="$refs.main_center_div.offsetHeight"></video>
              </div>
            </div>
            <div>
              <div class="video-list">
                <div v-for="item in videoList"
                    v-bind:video="item"
                    v-bind:key="item.id"
                    class="video-item position-relative"
                >
                    <div>
                        <video autoplay playsinline :ref="el => { if (el) videos.push(el) }" height="160" :muted="item.muted" :id="item.id"></video>
                        <button class="btn position-absolute top-50 start-50 translate-middle" @click.stop="main_center_stream = item.stream">
                          <i class="fas fa-thumbtack"></i>
                        </button>
                    </div>
                </div>
              </div>
            </div>
        </div>
        <div class="d-flex fixed-bottom m-4 align-items-center">
            <button class="btn_hangout" @click="this.$router.push('/')"><i class="fas fa-phone-alt"></i></button>

            <button class="btn_oval_dual_left ms-5" @click="setMyVideo()">
              <i class="fas fa-video me-2" v-if="myVideo"></i>
              <i class="fas fa-video-slash me-2" v-else></i>Camera
            </button>
            <button class="btn_oval_dual_right" @click="setMyAudio()">
              <i class="fas fa-microphone me-2" v-if="myAudio"></i>
              <i class="fas fa-microphone-slash me-2" v-else></i>Microphone
            </button>
            <button class="btn_share_screen ms-4" @click="shareScreen()"><i class="fas fa-desktop"></i></button>
            <button class="btn_circle ms-auto"><i class="far fa-smile"></i></button>
            <button class="btn_circle ms-4" @click="raise_hand"><i class="fas fa-hand-paper"></i></button>
            <button class="btn_circle more ms-4">...</button>
            <button class="btn_oval_dual_left ms-4"><i class="fas fa-user-alt me-2"></i>Participant</button>
            <button class="btn_oval_dual_right"><i class="far fa-comment-dots me-2"></i>Chat</button>
        </div>
    </div>
</template>

<script>
  const io = require("socket.io-client");
  const SimpleSignalClient = require('simple-signal-client');
  const bootstrap = require('bootstrap');

  export default {
    name: 'InClassStudent',
    components: {
    },
    beforeUpdate() {
      this.videos = []
    },
    data() {
      return {
        roomId: 'default-room',
        signalClient: null,
        localStream: null,
        videoList: [],
        canvas: null,
        socket: null,
        videos: [],
        myAudio: true,
        myVideo: true,
        student_button: [],
        at_quiz: false,
        quiz_data: {},
        socketURL: 'https://docker.yushan.tw',
        main_center_stream: null,
        screen_sharing: null,
      };
    },
    props: {
      enableLogs: {
        type: Boolean,
        default: true
      },
      peerOptions: {
        type: Object,  // NOTE: use these options: https://github.com/feross/simple-peer
        default() {
          return {};
        }
      },
      deviceId: {
        type: String,
        default: null
      }
    },
    watch: {
    },
    mounted() {
      /* var myModal = new bootstrap.Modal(document.getElementById('modal_interact_toolbox'), {
        backdrop: false
      })
      myModal.toggle() */
      const user_data = this.$store.state.user_data
      this.roomId = `${user_data.school}_${user_data.class}`
      console.log(this.roomId)
      this.join()
    },
    methods: {
        async join() {
            var that = this;
            console.log('join');
            this.socket = io.connect(this.socketURL, {path: "/socket/socket.io/" ,rejectUnauthorized: false, transports: ['websocket'] });
            this.signalClient = new SimpleSignalClient(this.socket);
            let constraints = {
            video: true,
            audio: true
            };
            if (that.deviceId) {
            constraints.video = { deviceId: { exact: that.deviceId } };
            }
            try {
            this.localStream = await navigator.mediaDevices.getUserMedia(constraints); 
            console.log('opened', this.localStream);
            } catch (error) {
            this.localStream = {id: 'no_mic_device'}
            }
            this.joinedRoom(this.localStream, true);
            this.signalClient.once('discover', (discoveryData) => {
            console.log('discovered', discoveryData)
            async function connectToPeer(peerID) {
                if (peerID == that.socket.id) return;
                try {
                console.log('Connecting to peer');
                const { peer } = await that.signalClient.connect(peerID, that.roomId, that.peerOptions);
                that.videoList.forEach(v => {
                    if (v.isLocal) {
                    that.onPeer(peer, v.stream);
                    }
                })
                } catch (e) {
                console.log('Error connecting to peer');
                }
            }
            discoveryData.peers.forEach((peerID) => connectToPeer(peerID));
            //that.$emit('opened-room', that.roomId);
            });
            this.signalClient.on('request', async (request) => {
            console.log('requested', request)
            const { peer } = await request.accept({}, that.peerOptions)
            console.log('accepted', peer);
            that.videoList.forEach(v => {
                if (v.isLocal) {
                that.onPeer(peer, v.stream);
                }
            })
            })
            this.signalClient.discover(that.roomId);
            this.socket.on('get_button', data => {
            console.log('get button')
            //console.log(data)
            that.student_button = data
            })
            this.socket.on('student_want_answer', data => {
            console.log('get student want answer')
            //console.log(data)
            that.quiz_data = {}
            that.quiz_data.name = data
            })
        
        },
        //------------------------------------------------------------------------------------
        onPeer(peer, localStream) {
            var that = this;
            console.log('onPeer');
            console.log(localStream)
            if(localStream.id != "no_mic_device"){
            peer.addStream(localStream);
            }
            peer.on('stream', (remoteStream) => {
            that.joinedRoom(remoteStream, false);
            peer.on('close', () => {
                var newList = [];
                that.videoList.forEach(function (item) {
                if (item.id !== remoteStream.id) {
                    newList.push(item);
                }
                });
                that.videoList = newList;
                that.$emit('left-room', remoteStream.id);
            });
            peer.on('error', (err) => {
                console.log('peer error ', err);
            });
            });
        },
        //------------------------------------------------------------------------------------
        joinedRoom(stream, isLocal) {
            var that = this;
            let found = that.videoList.find(video => {
            return video.id === stream.id
            })

            if (found === undefined) {
            let video = {
                id: stream.id,
                muted: isLocal,
                stream: stream,
                isLocal: isLocal
            };

            that.videoList.push(video);

            // Set main_center_stream 
            if(stream.main_stream != undefined && stream.main_stream == true){
                this.main_center_stream = stream
            }
            }

            setTimeout(function () {
            for (var i = 0, len = that.videos.length; i < len; i++) {
                if (that.videos[i].id === stream.id && stream.id != "no_mic_device") {
                that.videos[i].srcObject = stream;
                break;
                }
            }
            }, 500);
            
            //that.$emit('joined-room', stream.id);
        },
        //------------------------------------------------------------------------------------
        leave() {
            this.videoList.forEach(v => {
            try{
                v.stream.getTracks().forEach(t => t.stop())
            }
            catch(error){

            }
            });
            this.videoList = [];
            this.signalClient.peers().forEach(peer => peer.removeAllListeners())
            this.signalClient.destroy();
            this.signalClient = null;
            this.socket.destroy();
            this.socket = null;
        },
        //------------------------------------------------------------------------------------
        async shareScreen() {
            var that = this;
            if (navigator.mediaDevices == undefined) {
            console.log('Error: https is required to load cameras');
            return;
            }
            if(this.screen_sharing == null){
            try {
                var screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
                this.screen_sharing = screenStream.id
                this.joinedRoom(screenStream, true);
                //that.$emit('share-started', screenStream.id);
                that.signalClient.peers().forEach(p => that.onPeer(p, screenStream));
            } catch (e) {
                console.log('Media error: ' + JSON.stringify(e));
            }
            }
            else{
            // Close Screen
            this.main_center_stream = null
            let index = 0
            for(var i in this.videoList){
                console.log(this.videoList[i])
                if(this.videoList[i].id == this.screen_sharing){
                index = 1
                }
            }
            this.videoList.splice(index, 1)
            this.screen_sharing = null
            }
            },
        //------------------------------------------------------------------------------------
        log(message, data) {
            if (this.enableLogs) {
            console.log(message);
            if (data != null) {
                console.log(data);
            }
            }
            },
        //------------------------------------------------------------------------------------
        setMyAudio(){
            this.myAudio = !this.myAudio
            this.localStream.getAudioTracks()[0].enabled = this.myAudio
        },
        //------------------------------------------------------------------------------------
        setMyVideo(){
            this.myVideo = !this.myVideo
            this.localStream.getVideoTracks()[0].enabled = this.myVideo
        },
        //------------------------------------------------------------------------------------
        raise_hand(){
            console.log(this.$store.state.user_data)
            this.socket.emit('student_raise_hand', this.$store.state.user_data)
        }
    },
    async beforeRouteLeave (to, from , next) {
      const answer = await window.confirm('您要離開教室嗎')
      if (answer) {
        clearInterval(this.syncdata)
        this.leave()
        next()
      } else {
        next(false)
      }
    }

  };
</script>